<template>
  <van-picker
    ref="picker"
    :columns="options"
    :value-key="labelKey"
  />
</template>
<script>
  
  export default {
    name: "AtomPicker",
    data() {
      return {}
    },
    props: {
      options: {
        type: Array,
        default() {
          return []
        }
      },
      labelKey: {
        type: String,
        default: 'text'
      }
    },
    methods: {
      getValue() {
        return this.$refs.picker.getValues()
      }
    }
  };
</script>